import initHeader from './modules/header';
import initToshiPreview from './modules/toshi-preview';
import initJoinForm from './modules/join-form';
import initAnchors from './modules/anchors';
import calc from './modules/pricing';

function isTouchDevice() {
  return !!('ontouchstart' in window || navigator.maxTouchPoints);
};

if (isTouchDevice()) {
  document.documentElement.classList.add('touch');
  document.documentElement.classList.remove('no-touch');
} else {
  document.documentElement.classList.add('no-touch');
  document.documentElement.classList.remove('touch');
}

initHeader();
initToshiPreview();
initAnchors();

calc.init();

const joinFormElements = [...document.querySelectorAll('.join')];

for (const formElement of joinFormElements) {
  initJoinForm(formElement);
}
